import { Cart } from './Cart';

export enum TransactionState {
  FAILURE = 'Failure',
  PENDING = 'Pending',
  SUCCESS = 'Success',
  INITIAL = 'Initial',
}

export enum OrderState {
  OPEN = 'Open',
  CONFIRMED = 'Confirmed',
  COMPLETE = 'Complete',
  CANCELLED = 'Cancelled',
}

export enum PaymentState {
  BALANCE_DUE = 'BalanceDue',
  FAILED = 'Failed',
  PENDING = 'Pending',
  CREDIT_OWED = 'CreditOwed',
  PAID = 'Paid',
}

export interface ReturnLineItem {
  returnLineItemId?: string;
  lineItemId: string;
  count: number;
  comment?: string;
  createdAt?: Date;
}

export interface ReturnInfo {
  lineItems: ReturnLineItem[];
  returnDate?: Date;
  returnTrackingId?: string;
}

export enum ShipmentState {
  BACKORDER = 'Backorder',
  DELAYED = 'Delayed',
  DELIVERED = 'Delivered',
  PARTIAL = 'Partial',
  PENDING = 'Pending',
  READY = 'Ready',
  SHIPPED = 'Shipped',
}

export interface Order extends Cart {
  orderId: string;
  orderNumber?: string;
  orderVersion: string;
  orderState?: OrderState;
  createdAt?: Date;
  shipmentState?: ShipmentState;
  paymentState?: PaymentState;
  returnInfo?: ReturnInfo[];
  purchaseOrderNumber?: string;
}

export interface OrderLine {
  title: string;
  quantity: number;
  course_organization: string;
  description: string;
  status: string;
  line_price_excl_tax: string;
  unit_price_excl_tax: string;
  product?: {
    id: number;
    url: string;
    structure: string;
    product_class: string;
    title: string;
    price: string;
    expires: Date | string;
    attribute_values: {
      name: string;
      code: string;
      value: string;
    }[];
    is_available_to_buy: boolean;
    is_enrollment_code_product: boolean;
    stockrecords: {
      id: number;
      product: number;
      partner: number;
      partner_sku: string;
      price_currency: string;
      price_excl_tax: string;
    }[];
  };
}

export interface OrderHistoryResult {
  basket_discounts: unknown[] | null;
  billing_address: {
    first_name: string | null;
    last_name: string | null;
    line1: string | null;
    line2: string | null;
    postcode: string | null;
    state: string | null;
    country: string | null;
    city: string | null;
  };
  contains_credit_seat?: boolean | string;
  currency: string;
  date_placed: string;
  dashboard_url: string;
  discount: string | null;
  enable_hoist_order_history?: boolean | string;
  enterprise_learner_portal_url?: string | null;
  lines: OrderLine[];
  mobile_order: boolean;
  number: string;
  order_product_ids: string;
  payment_processor: string;
  payment_method: string;
  product_tracking?: string | null;
  status: string;
  total_before_discounts_incl_tax: string;
  total_excl_tax: string;
  user: {
    email: string;
    username: string;
  };
  vouchers: string[] | string | null;
}

export interface PaginatedOrderHistoryResult {
  count: string;
  next: number | null;
  previous: number | null;
  results: OrderHistoryResult[];
}

export type OrderHistoryResponse =
  | {
      isLoading: true;
      isError: false;
      orders: null;
    }
  | {
      isError: true;
      isLoading: false;
      orders: null;
    }
  | {
      isError: false;
      isLoading: false;
      orders: PaginatedOrderHistoryResult;
    };
